module.exports = __webpack_public_path__ + "img/20220411_125543.e45946a8.jpg";